import { RadioChecked, RadioEmpty } from 'pcln-icons';
import React from 'react';
import styled from 'styled-components';
import { applyVariations, getPaletteColor } from '../utils/utils';
const RadioWrap = /*#__PURE__*/styled.div.withConfig({
  displayName: "Radio__RadioWrap",
  componentId: "sc-7dqaqw-0"
})(["display:inline-block;color:", ";cursor:", ";&:hover > svg{", ";}", ""], getPaletteColor('text.light'), props => props.disabled ? `not-allowed` : `pointer`, props => {
  if (props.checked && !props.disabled) {
    return `color: ${getPaletteColor('dark')(props)} !important;`;
  }
  return props.disabled ? null : `color: ${getPaletteColor('base')(props)};`;
}, applyVariations('Radio'));
const RadioInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "Radio__RadioInput",
  componentId: "sc-7dqaqw-1"
})(["appearance:none;opacity:0;position:absolute;z-index:0;& ~ svg{border:1px solid transparent;border-radius:50%;padding:2px;}&:focus{box-shadow:none;& ~ svg{border:1px solid ", ";background-color:", ";}}&:checked ~ svg{color:", ";}&:disabled ~ svg{color:", ";cursor:not-allowed;}"], getPaletteColor('border.base'), getPaletteColor('background.light'), getPaletteColor('base'), getPaletteColor('border.base'));
const RadioCheckedIcon = /*#__PURE__*/styled(RadioChecked).withConfig({
  displayName: "Radio__RadioCheckedIcon",
  componentId: "sc-7dqaqw-2"
})(["vertical-align:middle;"]);
const RadioEmptyIcon = /*#__PURE__*/styled(RadioEmpty).withConfig({
  displayName: "Radio__RadioEmptyIcon",
  componentId: "sc-7dqaqw-3"
})(["vertical-align:middle;"]);
const RadioIcon = ({
  checked,
  ...props
}) => {
  return checked ? React.createElement(RadioCheckedIcon, {
    ...props
  }) : React.createElement(RadioEmptyIcon, {
    ...props
  });
};
/**
 * @public
 */
export const Radio = React.forwardRef(({
  color = 'primary',
  checked,
  disabled,
  size = 24,
  ...props
}, ref) => {
  const borderAdjustedSize = size + 4;
  const dataNameHelper = (checked, disabled) => {
    if (checked && disabled || !checked && disabled) {
      return 'disabled';
    }
    if (checked && !disabled) {
      return 'checked';
    }
    return 'unchecked';
  };
  return React.createElement(RadioWrap, {
    color: color,
    checked: checked,
    disabled: disabled,
    "data-name": dataNameHelper(checked, disabled)
  }, React.createElement(RadioInput, {
    type: 'radio',
    color: color,
    checked: checked,
    disabled: disabled,
    size: size,
    ...props,
    ref: ref
  }), React.createElement(RadioIcon, {
    checked: checked,
    size: borderAdjustedSize
  }));
});